import Action from '../../utils/Action';

export const SET_NAV_LOCATION = 'Nav.setLocation';
export const setNavLocation = (location) => Action.createDefault(SET_NAV_LOCATION, location);